import findIndex from 'lodash-es/findIndex';
import map from 'lodash-es/map';
import { NICmsContentField } from '@icms/core/content';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';

// Had to move this config to local codebase because of iCMS update and field types missmatches.

export function addKlevuRecommendationsVariant(fields: NICmsContentField.IField[], qty = 36): NICmsContentField.IField[] {
    const variantIndex = findIndex(fields, i => i.key === 'variant');

    if (variantIndex) {
        const variant = fields[variantIndex] as NICmsContentField.IChoiceField;

        if (Array.isArray(variant?.options)) {
            const key: string = KlevuSearch.recommendationsEngineId;

            variant.options.push({ key, title: 'Klevu Recommendations' });

            fields.splice(variantIndex + 1, 0, klevuTypeIdField);

            fields.splice(variantIndex + 2, 0, klevuEnablePersonalisationField);

            fields.splice(variantIndex + 3, 0, klevuLimitField);

            fields.splice(variantIndex + 4, 0, klevuCategoryIdFiled);

            fields.splice(variantIndex + 5, 0, klevuProductsIdsField(qty));

            fields.splice(variantIndex + 6, 0, klevuRecommendationIdFiled);
        }
    }

    return fields;
}

export function addKlevuContextRecommendationsVariant(fields: NICmsContentField.IField[]): NICmsContentField.IField[] {
    const variantIndex = findIndex(fields, i => i.key === 'variant');

    if (variantIndex) {
        const variant = fields[variantIndex] as NICmsContentField.IChoiceField;
        if (Array.isArray(variant?.options)) {
            variant.options.push({ key: KlevuSearch.contextRecommendationsEngineId, title: 'Klevu Context Recommendations' });
            fields.splice(variantIndex + 1, 0, klevuStrategyIdFiled);
        }
    }

    return fields;
}

export const klevuRecomendationsFileds = (qty?: number) => {
    return [
        {
            key: 'klevuTypeId',
            type: NICmsContentField.EFieldType.choice,
            required: true,
            title: 'Klevu recommendations type',
            options: map(KlevuSearch.ERecommendationTypeId, (value, key) => {
                return { key: value, title: key };
            }),
            canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) => isKlevuSelected(data)
        },
        {
            key: 'klevuEnablePersonalisation',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Klevu enable personalisation',
            canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
                isKlevuSelected(data) && data.klevuTypeId === KlevuSearch.ERecommendationTypeId.TrendingProducts
        },
        {
            key: 'klevuLimit',
            type: NICmsContentField.EFieldType.number,
            title: 'Items Limit',
            description: 'Max number of items that can be displayed',
            canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
                isKlevuSelected(data) && data.klevuTypeId === KlevuSearch.ERecommendationTypeId.VisuallySimilar
        },
        {
            key: 'klevuCategoryId',
            type: NICmsContentField.EFieldType.relation,
            title: 'Category',
            options: {
                type: 'category',
                qty: 1
            },
            canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) => isKlevuSelected(data) && displayCategoryField(data)
        },
        <NICmsContentField.IRelationField>{
            key: 'klevuProductsIds',
            type: NICmsContentField.EFieldType.relation,
            title: 'Products',
            options: {
                title: 'Product',
                type: 'product',
                multiple: true
            },
            canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) => isKlevuSelected(data) && displayProductsField(data)
        },
        {
            key: 'klevuRecommendationId',
            type: NICmsContentField.EFieldType.text,
            title: 'Klevu Recommendation ID',
            description:
                'The unique identifier for RecommendationsBanner which will be used to distinguish one banner from another. Required for tracking',
            canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
                isKlevuSelected(data) || isKlevuContextSelected(data) || isKlevuContextBasketSelected(data)
        },
        {
            key: 'strategyId',
            type: NICmsContentField.EFieldType.text,
            title: 'Strategy id',
            canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
                isKlevuSelected(data, KlevuSearch.contextRecommendationsEngineId)
        }
    ];
};

export const klevuTypeIdField = <NICmsContentField.IChoiceField>{
    key: 'klevuTypeId',
    type: NICmsContentField.EFieldType.choice,
    required: true,
    title: 'Klevu recommendations type',
    options: map(KlevuSearch.ERecommendationTypeId, (value, key) => {
        return { key: value, title: key };
    }),
    canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) => isKlevuSelected(data)
};

export const klevuEnablePersonalisationField = <NICmsContentField.IField>{
    key: 'klevuEnablePersonalisation',
    type: NICmsContentField.EFieldType.toggle,
    title: 'Klevu enable personalisation',
    canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
        isKlevuSelected(data) && data.klevuTypeId === KlevuSearch.ERecommendationTypeId.TrendingProducts
};

export const klevuLimitField = <NICmsContentField.IField>{
    key: 'klevuLimit',
    type: NICmsContentField.EFieldType.number,
    title: 'Items Limit',
    description: 'Max number of items that can be displayed',
    canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
        isKlevuSelected(data) && data.klevuTypeId === KlevuSearch.ERecommendationTypeId.VisuallySimilar
};

export const klevuCategoryIdFiled = <NICmsContentField.IRelationField>{
    key: 'klevuCategoryId',
    type: NICmsContentField.EFieldType.relation,
    title: 'Category',
    options: {
        title: 'Category',
        type: 'category',
        qty: 1
    },
    canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) => isKlevuSelected(data) && displayCategoryField(data)
};

export const klevuProductsIdsField = (qty = 36) =>
    <NICmsContentField.IRelationField>{
        key: 'klevuProductsIds',
        type: NICmsContentField.EFieldType.relation,
        title: 'Products',
        options: {
            title: 'Product',
            type: 'product',
            multiple: true
        },
        canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) => isKlevuSelected(data) && displayProductsField(data)
    };

export const klevuRecommendationIdFiled = <NICmsContentField.IField>{
    key: 'klevuRecommendationId',
    type: NICmsContentField.EFieldType.text,
    title: 'Klevu Recommendation ID',
    description:
        'The unique identifier for RecommendationsBanner which will be used to distinguish one banner from another. Required for tracking',
    canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
        isKlevuSelected(data) || isKlevuContextSelected(data) || isKlevuContextBasketSelected(data)
};

export const klevuStrategyIdFiled: NICmsContentField.IField = {
    key: 'strategyId',
    type: NICmsContentField.EFieldType.text,
    title: 'Strategy id',
    canShow: (data: KlevuSearch.IRecommendationsModelCarouselLoadRequest) =>
        isKlevuSelected(data, KlevuSearch.contextRecommendationsEngineId)
};

export function isKlevuSelected(
    data: KlevuSearch.IRecommendationsModelCarouselLoadRequest | KlevuSearch.IRecommendationsRelatedProductsOptions,
    engine: string = KlevuSearch.recommendationsEngineId
): boolean {
    return (
        (<KlevuSearch.IRecommendationsModelCarouselLoadRequest>data)?.variant === engine ||
        (<KlevuSearch.IRecommendationsRelatedProductsOptions>data)?.engine === engine
    );
}

export function isKlevuContextSelected(
    data: KlevuSearch.IRecommendationsModelCarouselLoadRequest | KlevuSearch.IRecommendationsRelatedProductsOptions,
    engine: string = KlevuSearch.contextRecommendationsEngineId
): boolean {
    return (
        (<KlevuSearch.IRecommendationsModelCarouselLoadRequest>data)?.variant === engine ||
        (<KlevuSearch.IRecommendationsRelatedProductsOptions>data)?.engine === engine
    );
}

export function isKlevuContextBasketSelected(
    data: KlevuSearch.IRecommendationsModelCarouselLoadRequest | KlevuSearch.IRecommendationsRelatedProductsOptions,
    engine: string = KlevuSearch.contextRecommendationsBasketEngineId
): boolean {
    return (
        (<KlevuSearch.IRecommendationsModelCarouselLoadRequest>data)?.variant === engine ||
        (<KlevuSearch.IRecommendationsRelatedProductsOptions>data)?.engine === engine
    );
}

export function displayProductsField(
    data: KlevuSearch.IRecommendationsModelCarouselLoadRequest | KlevuSearch.IRecommendationsRelatedProductsOptions
): boolean {
    return (
        [
            KlevuSearch.ERecommendationTypeId.SimilarProducts,
            KlevuSearch.ERecommendationTypeId.TrendingProducts,
            KlevuSearch.ERecommendationTypeId.CustomersAlsoViewed,
            KlevuSearch.ERecommendationTypeId.CustomersAlsoBought,
            KlevuSearch.ERecommendationTypeId.VisuallySimilar
        ].indexOf(data.klevuTypeId) > -1
    );
}

export function displayCategoryField(
    data: KlevuSearch.IRecommendationsModelCarouselLoadRequest | KlevuSearch.IRecommendationsRelatedProductsOptions
): boolean {
    return (
        [KlevuSearch.ERecommendationTypeId.NewArrivals, KlevuSearch.ERecommendationTypeId.TrendingProducts].indexOf(data.klevuTypeId) > -1
    );
}
